import React from "react";
import { useAuth } from "../context/AuthContext";
import AdminDashboard from "./dashboards/AdminDashboard";
import OwnerDashboard from "./dashboards/OwnerDashboard";
import AgentDashboard from "./dashboards/AgentDashboard";
import BuyerDashboard from "./dashboards/BuyerDashboard";
import VisitorDashboard from "./dashboards/VisitorDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;

  const roleLabel = {
    admin: "Administrator", owner: "Property Owner", agent: "Agent",
    buyer: "Buyer / Tenant", visitor: "Visitor",
  }[user.role];

  return (
    <main className="bg-ink min-h-screen pt-32 pb-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2 mb-10">
          <div>
            <p className="text-brand-600 text-sm font-medium mb-1">{roleLabel} Dashboard</p>
            <h1 className="font-display text-4xl font-bold text-navy" data-testid="dashboard-greeting">
              Hi, {user.name?.split(" ")[0] || "there"} 👋
            </h1>
          </div>
          <span className="px-4 py-2 rounded-full bg-surface border border-neutral-200 shadow-card text-sm text-neutral-600 capitalize" data-testid="dashboard-role">
            Role: {user.role}
          </span>
        </div>

        {user.role === "admin" && <AdminDashboard />}
        {user.role === "owner" && <OwnerDashboard />}
        {user.role === "agent" && <AgentDashboard />}
        {user.role === "buyer" && <BuyerDashboard />}
        {user.role === "visitor" && <VisitorDashboard />}
      </div>
    </main>
  );
}
